export const FORMAS_CONSTITUICAO = [
  { Id: "2", Descricao: "S. A." },
  { Id: "3", Descricao: "Limitada" },
  { Id: "4", Descricao: "Sociedade de Capital e Indústria" },
  { Id: "5", Descricao: "Assoc. Civil (Ent. Soc./Clube/Igreja/Fund.)" },
  { Id: "6", Descricao: "Sociedade Comandita por Ações" },
  { Id: "7", Descricao: "Sociedade Civil com Fins Lucrativos" },
  { Id: "8", Descricao: "Sociedade em Conta Participação" },
  { Id: "9", Descricao: "Cooperativa Rural/de Crédito/Habit." },
  { Id: "10", Descricao: "Filial/Sucursal/Ag. Empr. Sediada no Exterior" },
  { Id: "11", Descricao: "Empresa Pública" },
];
